import { Component, OnInit } from '@angular/core';
import { SiteSummary } from 'app/_models/site-summary.model';
import { NotificationService } from 'app/_services/notification.service';
import { ReportsService } from 'app/_services/reports.service';
import { SiteFormsService } from 'app/_services/site-forms.service';
import { SiteService } from 'app/_services/site.service';
import { utils, WorkBook, WorkSheet, writeFile } from 'xlsx';

@Component({
  selector: 'app-site-form-report',
  templateUrl: './site-form-report.component.html',
})
export class SiteFromReportComponent implements OnInit {
  generatedReportData = [];

  public sitesArray: any[] = [];
  public formsArray: any[] = [];

  // date filters
  public fromDate: Date;
  public toDate: Date;

  public selectedSites: any = [];
  public selectedForms: any = [];

  constructor(
    private reportsService: ReportsService,
    private siteService: SiteService,
    private siteFormsService: SiteFormsService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.toDate = new Date();
    const tempFromDate = new Date().setDate(this.toDate.getDate() - 30);
    this.fromDate = new Date(tempFromDate);

    this.getSites();
    this.getSiteForms();
  }

  private getSites() {
    this.siteService.getSiteListSummary().subscribe((data: SiteSummary[]) => {
      data.forEach((element: SiteSummary) => {
        const item = {
          label: element.siteName,
          value: element.siteId,
        };
        this.sitesArray.push(item);
      });
    });
  }

  private getSiteForms() {
    this.siteFormsService
      .getAllSiteForms(
        {
          size: 999999,
          page: 0,
          totalRecords: 0,
        },
        ['lastModifiedDate' + ',' + 'desc'],
        undefined
      )
      .subscribe((data: any) => {
        data.body.forEach((element) => {
          const item = {
            label: element.name,
            value: element.id,
          };
          this.formsArray.push(item);
        });
      });
  }

  submitForm() {
    if (!this.fromDate || !this.toDate || !this.selectedForms.length) {
      this.notificationService.notify('danger', 'Incomplete', 'Please complete all required fields.');
    } else {
      this.generateReport();
    }
  }

  generateReport() {
    const body = {
      startDate: this.fromDate.getTime(),
      endDate: this.toDate.getTime(),
      sort: 'createdDate,asc',
      size: 999999,
      page: 0,
      siteFormId: null,
      siteId: null,
    };

    this.selectedForms.forEach(form => {
      body.siteFormId = form.value;

      if (this.selectedSites.length) {
        this.selectedSites.forEach(site => {
          body.siteId = site.value;

          this.getDataAndGenerateReportFile(body, form.label, site.label);
        });
      } else {
        this.getDataAndGenerateReportFile(body, form.label, '');
      }
    });
  }

  private getDataAndGenerateReportFile(body: any, formName: any, siteName: string) {
    this.reportsService.getUserSessionsWithSiteForms(body).subscribe((data: any) => {
      if (data && data.body && data.body.length) {
        this.loopRecords(data.body, formName, siteName);
      } else {
        siteName = siteName ? ' - ' + siteName : '';
        this.notificationService.notify('warning', 'No Data', `${formName}${siteName} - There was no data found for your chosen options.`);
      }
    });
  }

  private loopRecords(arr: any[], formName, siteName) {
    for (let i = 0; i < arr.length; i++) {
      arr[i].formQuestions = arr[i].formQuestions ? JSON.parse(arr[i].formQuestions) : arr[i].formQuestions;

      arr[i].formResponse = arr[i].formResponse ? JSON.parse(arr[i].formResponse) : arr[i].formResponse;

      for (let j = 0; j < arr[i].formQuestions.length; j++) {
        const question = arr[i].formQuestions[j];
        const answer = arr[i].formResponse[j];

        if (question.category === 'input') {
          arr[i][question.label ? 'Q: ' + question.label.trim() : 'Unknown Question'] = answer ? answer + ''.trim() : '';
        }
      }
    }

    this.export(arr, formName, siteName);
  }

  private export(formattedData, formName, siteName) {
    for (let i = 0; i < formattedData.length; i++) {
      delete formattedData[i]['formVersionNum'];
      delete formattedData[i]['formQuestions'];
      delete formattedData[i]['formResponse'];
      delete formattedData[i]['site_form_id'];
      delete formattedData[i]['site_form_version_id'];
      delete formattedData[i]['version_number'];
      delete formattedData[i]['user_session_id'];
      delete formattedData[i]['form_data'];
      delete formattedData[i]['respones_id'];
      delete formattedData[i]['response_data'];
      delete formattedData[i]['siteId'];

      // getting time taken
      let duration = '';

      if (formattedData[i].startTime && formattedData[i].endTime) {
        let diffTime = Math.abs(new Date(formattedData[i].startTime).valueOf() - new Date(formattedData[i].endTime).valueOf());
        let days = diffTime / (24 * 60 * 60 * 1000);
        let hours = (days % 1) * 24;
        let minutes = (hours % 1) * 60;
        let secs = (minutes % 1) * 60;
        [days, hours, minutes, secs] = [Math.floor(days), Math.floor(hours), Math.floor(minutes), Math.floor(secs)];

        const dayString = days ? `${days} days, ` : '';

        duration = `${dayString}${hours}:${minutes}:${secs}`;
      }

      formattedData[i].duration = duration;
      // eof getting time taken
    }

    var wscols = [
      { width: 20 },
      { width: 19 },
      { width: 19 },
      { width: 18 },
      { width: 10},
      { width: 12 },
      { width: 30 },
      { width: 25 },
      { width: 18 },
      { width: 10 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 }
    ];

    /* generate worksheet */
    let ws: WorkSheet = utils.json_to_sheet(formattedData, {
      header: ['siteName', 'formSubmittedTimeStr', 'startTimeStr', 'endTimeStr', 'duration', 'assetName', 'workOrderStatus', 'workOrderDescription', 'workOrderId', 'reason', 'ownerFullName', 'ownerLogin', 'maintenanceCompany','additionalWorkers', 'formName'],
      cellDates: true,
      dateNF: 'YYYY-MM-DD HH:mm:ss',
    });

    ws["!cols"] = wscols;

    const headerNames = [['Site', 'Form Submitted Time', 'Start Time', 'End Time', 'Duration', 'Asset', 'Work Order Status', 'Work Order Description', 'Work Order Id', 'Reason', 'Owner Name', 'Owner Login', 'Maintenance Company','Additional Workers', 'Form Name']];
    utils.sheet_add_aoa(ws, headerNames);

    /* generate workbook and add the worksheet */
    const wb: WorkBook = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Sheet1');

    const today = new Date();

    siteName = siteName ? ' - ' + siteName : '';
    /* save to file */
    writeFile(wb, `Session Report - ${formName}${siteName} ${today.toLocaleDateString()}.xlsx`);
  }
}
